import { StaffRowFragment } from "../../../graphql/graphql-generated.types";
import { PayRatesValues } from "./AppointmentPayRateList.types";

export function createPayRatesFormData(
  staff: StaffRowFragment & { currencySymbol: string },
): PayRatesValues {
  return {
    types: staff.appointmentTypes.map((appt) => {
      const payRate = staff.payRates.find(
        (pr) => pr.appointmentType.uuid === appt.uuid,
      );
      if (payRate) {
        return {
          saved: true,
          enabled: true,
          payRateUuid: payRate.uuid,
          appointmentType: appt,
          rateType: {
            label: payRate.rateType === "FLAT" ? staff.currencySymbol : "%",
            value: payRate.rateType,
          },
          value: payRate.value,
        };
      }
      return {
        enabled: false,
        saved: false,
        appointmentType: appt,
      };
    }),
  };
}
